import React, { useState } from "react";
import Swal from "sweetalert2";
import "./contact-form.css";
import { Link } from "react-router-dom";
import API_BASE_URL from "../config/api";
import PageHeader from "./PageHeader";
const courses = [
  "Mock Test",
  "CPL Ground Class",
  "Flight Training",
  "Complete Pilot Training Process",
];

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
    course: [],
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  /* =====================
     Handle Change
  ====================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));

    if (submitted) {
      setErrors((s) => ({ ...s, [name]: "" }));
    }
  };

  const handleCourseChange = (e) => {
    const { value, checked } = e.target;

    setForm((s) => ({
      ...s,
      course: checked
        ? [...s.course, value]
        : s.course.filter((c) => c !== value),
    }));

    if (submitted) {
      setErrors((s) => ({ ...s, course: "" }));
    }
  };

  /* =====================
     Validation (ON SUBMIT ONLY)
  ====================== */
  const validate = () => {
    const e = {};

    if (!form.name.trim()) e.name = "Name is required.";
    if (form.email.trim() !== '') {
      if (!/^\S+@\S+\.\S+$/.test(form.email.trim()))
        e.email = "Enter a valid email address.";
    }
    if (!form.phone.trim()) e.phone = "Mobile number is required.";
    else if (!/^[0-9]{10}$/.test(form.phone.trim()))
      e.phone = "Enter valid 10 digit mobile number.";

    if (!form.city.trim()) e.city = "City is required.";
    if (!form.course.length) e.course = "Please select at least one course.";
    if (!form.message.trim()) e.message = "Query is required.";

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  /* =====================
     Submit
  ====================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (!validate()) return;

    setLoading(true);

    Swal.fire({
      title: "Submitting...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const fd = new FormData();
      Object.keys(form).forEach((k) => {
        if (k === "course") {
          form.course.forEach((c) => fd.append("course[]", c));
        } else {
          fd.append(k, form[k].trim());
        }
      });

      const res = await fetch(
        `${API_BASE_URL}/contact_enquiry.php`,
        { method: "POST", body: fd }
      );
      const data = await res.json();

      Swal.close();

      if (data.status === "success") {
        Swal.fire("Success", "Enquiry submitted successfully!", "success");
        setForm({
          name: "",
          email: "",
          phone: "",
          city: "",
          message: "",
          course: [],
        });
        setErrors({});
        setSubmitted(false);
      } else {
        Swal.fire("Error", data.message || "Submission failed", "error");
      }
    } catch {
      Swal.close();
      Swal.fire("Server Error", "Please try again later", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>

      {/* ================= HEADER ================= */}
     <PageHeader
        title="Contact Us"
        bgImage="assets/img/about-img.png"
      />



      {/* ================= MAP ================= */}

      {/* ================= CONTACT ================= */}
      <section className="contact section">
        <div className="container">
          <div className="row gy-4">

            {/* ===== LEFT SIDE DETAILS ===== */}
            <div className="col-xl-4 col-lg-4 col-md-12">
              {/* Contact Info Block */}
              <div className="eflorio-wrap-block mb-4">
                <div className="eflorio-wrap-group">
                  <div className="eflorio-wrap-body">
                    <div className="eflorio-list-groups">

                      {/* Email */}
                      <div className="single-eflorio-list d-flex mb-3">
                        <div className="eflorio-list-icons me-3">
                          <i className="fa-solid fa-envelope-circle-check text-main"></i>
                        </div>
                        <div className="eflorio-list-captions" style={{ textAlign: 'left' }}>
                          <label>Email Address</label>
                          <h6 className="mb-0">info@thepilotguide.in</h6>
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="single-eflorio-list d-flex mb-3">
                        <div className="eflorio-list-icons me-3">
                          <i className="fa-solid fa-phone-volume text-main"></i>
                        </div>
                        <div className="eflorio-list-captions" style={{ textAlign: 'left' }}>
                          <label>Contact No.</label>
                          <h6 className="mb-0">+91 9167798781</h6>
                        </div>
                      </div>

                      {/* Location */}
                      <div className="single-eflorio-list d-flex align-items-start mb-3">
                        <div className="eflorio-list-icons me-3 mt-1">
                          <i className="fa-solid fa-map-location-dot text-main fs-4"></i>
                        </div>
                        <div className="eflorio-list-captions text-start">
                          <label>Location</label>
                          <h6 className="mb-0 lh-base">
                            VJ House 3rd Floor, Room No: 13,<br />
                            Road No. 4,<br />
                            Opp. Playground Pandurang Wadi,<br />
                            Goregaon East,<br />
                            Mumbai, Maharashtra 400063, India
                            <Link to="https://www.google.com/maps?ll=19.172027,72.849988&z=16&t=h&hl=en&gl=US&mapclient=embed&cid=8880572293932132772" target="_blank" className="d-block mt-2 text-main">
                              View on Google Maps
                            </Link>
                          </h6>
                        </div>
                      </div>
                      <div className="single-eflorio-list d-flex align-items-start mb-4">
                        <div className="eflorio-list-icons me-3">
                          <i className="fa-solid fa-building-circle-check text-main fs-4"></i>
                        </div>
                        <div className="eflorio-list-captions" style={{ textAlign: 'left' }}>
                          <label>Bussiness Hours</label>
                          <h6 className="mb-0"><p className="mb-0" style={{ lineHeight: '1.5' }}>
                            11:00 AM - 8:00 PM
                          </p></h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Share Profile */}
              <div className="sidefr-usr-block">
                <div className="cndts-share-block">
                  <div className="cndts-share-title">
                    <h5>Social Links</h5>
                  </div>
                  <div className="cndts-share-list">
                    <ul className="list-unstyled d-flex gap-3">
                      <li><Link to="https://www.facebook.com/rightsourceaviation/" target="_blank"><i className="fa-brands fa-facebook-f"></i></Link></li>
                      <li><Link to="https://www.linkedin.com/company/right-source-aviation/about/" target="_blank"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                      <li><Link to="https://www.youtube.com/@rightsourceaviation5853" target="_blank"><i className="fa-brands fa-youtube"></i></Link></li>
                      <li><Link to="https://www.instagram.com/rsa.pilot.academy/" target="_blank"><i className="fa-brands fa-instagram"></i></Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== RIGHT SIDE FORM ===== */}
            <div className="col-lg-8 col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="row gy-4">

                  {[
                    ["name", "Name", "Enter your full name"],
                    ["phone", "Mobile No.", "Enter 10 digit mobile number"],
                    ["city", "City", "Enter your city"],
                    ["email", "Email", "Enter your email address"],
                  ].map(([key, label, placeholder]) => (
                    <div className="col-md-6" key={key}>
                      <label className="fw-semibold">
                        {label} <span className="text-danger">{key !== "email" ? "*" : ""}</span>
                      </label>
                      <input
                        type="text"
                        name={key}
                        placeholder={placeholder}
                        value={form[key]}
                        onChange={handleChange}
                        className={`form-control ${submitted && errors[key] ? "is-invalid" : ""
                          }`}
                      />
                      {submitted && errors[key] && (
                        <div className="invalid-feedback d-flex">
                          <i className="fa-solid fa-circle-exclamation me-1"></i>
                          {errors[key]}
                        </div>
                      )}
                    </div>
                  ))}

                  {/* COURSE */}
                  <div className="col-md-12">
                    <label className="form-label fw-semibold">
                      Course Interested In <span className="text-danger">*</span>
                    </label>

                    <div className="d-flex flex-wrap gap-4 mt-2">
                      {courses.map((c) => (
                        <div className="form-check" key={c}>
                          <input
                            type="checkbox"
                            value={c}
                            checked={form.course.includes(c)}
                            onChange={handleCourseChange}
                            className="form-check-input"
                          />
                          <label className="form-check-label">{c}</label>
                        </div>
                      ))}
                    </div>

                    {/* 🔥 FULL WIDTH LEFT-FLOAT ERROR */}
                    {submitted && errors.course && (
                      <div className="course-error">
                        <i className="fa-solid fa-circle-exclamation"></i>
                        {errors.course}
                      </div>
                    )}
                  </div>


                  {/* MESSAGE */}
                  <div className="col-md-12">
                    <label className="fw-semibold">
                      Ask Your Query <span className="text-danger">*</span>
                    </label>
                    <textarea
                      rows="5"
                      name="message"
                      placeholder="Type your query here..."
                      value={form.message}
                      onChange={handleChange}
                      className={`form-control ${submitted && errors.message ? "is-invalid" : ""
                        }`}
                    />
                    {submitted && errors.message && (
                      <div className="invalid-feedback d-flex">
                        <i className="fa-solid fa-circle-exclamation me-1"></i>
                        {errors.message}
                      </div>
                    )}
                  </div>

                  {/* SUBMIT */}
                  <div className="col-md-12 text-center">
                    <button
                      type="submit"
                      className="btn btn-main full-width"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit Enquiry"}
                    </button>
                  </div>

                </div>
              </form>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
